import SetUp from './SetUp'
import { connect } from 'react-redux'

const mapStateToProps = state => {
  return {
    selectedLanguage: state.LANGUAGE.selectedLanguage
  }
}

export default connect(mapStateToProps)(SetUp)



// WEBPACK FOOTER //
// ./src/setup/index.js